import axios from "axios";
import { baseUriCoreApi } from "src/config";
import { msalInstance } from "src/lib/msal";

type SearchZipCode = {
    postal_code: string;
    country_code: string;
    latitude: string;
    longitude: string;
    city: string;
    state: string;
    city_en: string;
    state_en: string;
    state_code: string;
    province: string;
    province_code: string;
    stateCharacterCode: string;
};
type SearchZipCodeResponse = {
    status: string;
    data: {
        zipCodeSearch: SearchZipCode[];
    };
};
export const coreApiInstance = axios.create({
    baseURL: baseUriCoreApi,
});

coreApiInstance.interceptors.request.use(
    async (config) => {
        const account = msalInstance.getAllAccounts()[0];
        if (account) {
            const { accessToken } = await msalInstance.acquireTokenSilent({
                scopes: ["User.Read"],
                account: account,
            });

            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

export async function getZipCodeInfo({
    zipCode,
    country,
}: {
    zipCode: string;
    country: string;
}) {
    const response = await coreApiInstance.get<SearchZipCodeResponse>(
        `/search-zip-code`,
        {
            params: {
                codes: zipCode,
                country: country,
            },
        },
    );
    return response.data.data.zipCodeSearch;
}
